import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionBusinessService } from 'src/app/account/services/subscription-business.service';

@Pipe({
  name: 'enableSubscriptionFeature'
})
export class EnableSubscriptionFeaturePipe implements PipeTransform {

  constructor(private subscriptionBusinessService: SubscriptionBusinessService) {}

  transform(role: any, ...args: any[]): any {
    return this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(role);
  }

}
